// extracted by mini-css-extract-plugin
module.exports = {"container":"AnimLogoMobile-module--container--3RMIG","containerHor":"AnimLogoMobile-module--containerHor--mlwqa"};